import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import { useRoute } from 'vue2-helpers/vue-router';

export type TabEntry = {
  to: string; label: string; isNew: boolean; includedRouteNames?:string[]; disabled?:boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXContentAreaTabs',
  props: {
  tabs: {
    type: Array as PropType< TabEntry[]>,
    default: () => []
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();



const displayedTabs = computed(() => props.tabs.map((tab) => {
  const isActive = tab?.includedRouteNames?.includes(route.name ?? '')
      || route.path === tab.to;
  return ({
    isActive,
    ...tab
  });
}));


return { __sfc: true,route, props, displayedTabs, BCXContentArea }
}

})